import { useEffect, useState } from "react";

/**
 * Custom hook for detecting system color scheme preference.
 *
 * Features:
 * - Detects system dark/light mode preference
 * - Listens for changes in system color scheme
 * - Supports both modern and legacy event listeners
 * - Handles SSR environments gracefully
 * - Automatically cleans up event listeners
 * - Returns consistent light/dark mode values
 *
 * @returns Object containing current color scheme mode
 */
export const usePrefersColorScheme = (): { mode: "light" | "dark" } => {
  const [systemPrefersDark, setSystemPrefersDark] = useState();

  useEffect(() => {
    function isSystemDark(event: any) {
      setSystemPrefersDark(event.matches);
    }
    if (typeof window !== "undefined") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

      if (mediaQuery?.addEventListener != null) {
        mediaQuery.addEventListener("change", isSystemDark);
      } else {
        mediaQuery.addListener(isSystemDark);
      }

      return () => {
        if (mediaQuery?.addEventListener != null) {
          mediaQuery.removeEventListener("change", isSystemDark);
        } else {
          mediaQuery.removeListener(isSystemDark);
        }
      };
    }
  }, []);

  return {
    mode: systemPrefersDark ? "dark" : "light",
  };
};
